interface InnerHeaderProps {
  title: string;
  subtitle: string;
  backgroundImage: string;
}

export default function InnerHeader({ title, subtitle, backgroundImage }: InnerHeaderProps) {
  return (
    <div className="relative bg-gray-900 min-h-[420px]">
      <div className="absolute inset-0">
        <img
          src={backgroundImage}
          alt=""
          width={1920}
          height={500}
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gray-900/40 mix-blend-multiply" />
      </div>
      <div className="relative max-w-7xl mx-auto py-40 px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center text-center">
        <h1 className="text-4xl font-bold text-white mb-4">{title}</h1>
        <p className="text-xl text-white/90 max-w-2xl">
          {subtitle}
        </p>
      </div>
    </div>
  );
}
